/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  SessionAdminArtifactGetRequest,
  SessionAdminBootstrapRequest,
  SessionAdminFileGetRequest,
  SessionAdminGetRequest,
  SessionAdminLiveStreamRequest,
  SessionAdminSendRequest,
  SessionArtifactContentResponse,
  SessionArtifactGetRequest,
  SessionBootstrapResponse,
  SessionFileContentResponse,
  SessionFileGetRequest,
  SessionFileUploadRequest,
  SessionFileUploadResponse,
  SessionGatewayAccessRequest,
  SessionGatewayAccessResponse,
  SessionGetRequest,
  SessionGetResponse,
  SessionLiveStreamRequest,
  SessionOpenRequest,
  SessionOpenResponse,
  SessionRelayArtifactRequest,
  SessionRelayArtifactResponse,
  SessionRelayDeliveryRequest,
  SessionRelayDeliveryResponse,
  SessionRelayFileRequest,
  SessionRelayFileResponse,
  SessionRelayInboundRequest,
  SessionRelayInboundResponse,
  SessionRelayRuntimeEventRequest,
  SessionRelayRuntimeEventResponse,
  SessionRuntimeArtifactGetRequest,
  SessionRuntimeArtifactGetResponse,
  SessionRuntimeContextRequest,
  SessionRuntimeContextResponse,
  SessionRuntimeFileGetRequest,
  SessionRuntimeFileGetResponse,
  SessionSendResponse,
  SessionThinkingRequest,
  SessionThinkingResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiSessionsBootstrapUrl = () => {




  return `/api/sessions/bootstrap`
}

export const postApiSessionsBootstrap = async ( options?: RequestInit): Promise<SessionBootstrapResponse> => {

  return orvalControlFetch<SessionBootstrapResponse>(getPostApiSessionsBootstrapUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiSessionsBootstrapMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsBootstrap>>, TError,void, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsBootstrap>>, TError,void, TContext> => {

const mutationKey = ['postApiSessionsBootstrap'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsBootstrap>>, void> = () => {


          return  postApiSessionsBootstrap(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsBootstrapMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsBootstrap>>>

    export type PostApiSessionsBootstrapMutationError = unknown

    export const usePostApiSessionsBootstrap = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsBootstrap>>, TError,void, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsBootstrap>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostApiSessionsBootstrapMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsAdminBootstrapUrl = () => {




  return `/api/sessions/admin/bootstrap`
}

export const postApiSessionsAdminBootstrap = async (sessionAdminBootstrapRequest: SessionAdminBootstrapRequest, options?: RequestInit): Promise<SessionBootstrapResponse> => {

  return orvalControlFetch<SessionBootstrapResponse>(getPostApiSessionsAdminBootstrapUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionAdminBootstrapRequest,)
  }
);}




export const getPostApiSessionsAdminBootstrapMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminBootstrap>>, TError,{data: SessionAdminBootstrapRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminBootstrap>>, TError,{data: SessionAdminBootstrapRequest}, TContext> => {

const mutationKey = ['postApiSessionsAdminBootstrap'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsAdminBootstrap>>, {data: SessionAdminBootstrapRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsAdminBootstrap(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsAdminBootstrapMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsAdminBootstrap>>>
    export type PostApiSessionsAdminBootstrapMutationBody = SessionAdminBootstrapRequest
    export type PostApiSessionsAdminBootstrapMutationError = unknown

    export const usePostApiSessionsAdminBootstrap = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminBootstrap>>, TError,{data: SessionAdminBootstrapRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsAdminBootstrap>>,
        TError,
        {data: SessionAdminBootstrapRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsAdminBootstrapMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsGetUrl = () => {




  return `/api/sessions/get`
}

export const postApiSessionsGet = async (sessionGetRequest: SessionGetRequest, options?: RequestInit): Promise<SessionGetResponse> => {

  return orvalControlFetch<SessionGetResponse>(getPostApiSessionsGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionGetRequest,)
  }
);}




export const getPostApiSessionsGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsGet>>, TError,{data: SessionGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsGet>>, TError,{data: SessionGetRequest}, TContext> => {

const mutationKey = ['postApiSessionsGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsGet>>, {data: SessionGetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsGet>>>
    export type PostApiSessionsGetMutationBody = SessionGetRequest
    export type PostApiSessionsGetMutationError = unknown

    export const usePostApiSessionsGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsGet>>, TError,{data: SessionGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsGet>>,
        TError,
        {data: SessionGetRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsGetMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsOpenUrl = () => {




  return `/api/sessions/open`
}

export const postApiSessionsOpen = async (sessionOpenRequest: SessionOpenRequest, options?: RequestInit): Promise<SessionOpenResponse> => {

  return orvalControlFetch<SessionOpenResponse>(getPostApiSessionsOpenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionOpenRequest,)
  }
);}




export const getPostApiSessionsOpenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsOpen>>, TError,{data: SessionOpenRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsOpen>>, TError,{data: SessionOpenRequest}, TContext> => {

const mutationKey = ['postApiSessionsOpen'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsOpen>>, {data: SessionOpenRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsOpen(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsOpenMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsOpen>>>
    export type PostApiSessionsOpenMutationBody = SessionOpenRequest
    export type PostApiSessionsOpenMutationError = unknown

    export const usePostApiSessionsOpen = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsOpen>>, TError,{data: SessionOpenRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsOpen>>,
        TError,
        {data: SessionOpenRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsOpenMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsGatewayAccessUrl = () => {




  return `/api/sessions/gateway/access`
}

export const postApiSessionsGatewayAccess = async (sessionGatewayAccessRequest: SessionGatewayAccessRequest, options?: RequestInit): Promise<SessionGatewayAccessResponse> => {

  return orvalControlFetch<SessionGatewayAccessResponse>(getPostApiSessionsGatewayAccessUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionGatewayAccessRequest,)
  }
);}




export const getPostApiSessionsGatewayAccessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsGatewayAccess>>, TError,{data: SessionGatewayAccessRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsGatewayAccess>>, TError,{data: SessionGatewayAccessRequest}, TContext> => {

const mutationKey = ['postApiSessionsGatewayAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsGatewayAccess>>, {data: SessionGatewayAccessRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsGatewayAccess(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsGatewayAccessMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsGatewayAccess>>>
    export type PostApiSessionsGatewayAccessMutationBody = SessionGatewayAccessRequest
    export type PostApiSessionsGatewayAccessMutationError = unknown

    export const usePostApiSessionsGatewayAccess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsGatewayAccess>>, TError,{data: SessionGatewayAccessRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsGatewayAccess>>,
        TError,
        {data: SessionGatewayAccessRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsGatewayAccessMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsAdminGetUrl = () => {




  return `/api/sessions/admin/get`
}

export const postApiSessionsAdminGet = async (sessionAdminGetRequest: SessionAdminGetRequest, options?: RequestInit): Promise<SessionGetResponse> => {

  return orvalControlFetch<SessionGetResponse>(getPostApiSessionsAdminGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionAdminGetRequest,)
  }
);}




export const getPostApiSessionsAdminGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminGet>>, TError,{data: SessionAdminGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminGet>>, TError,{data: SessionAdminGetRequest}, TContext> => {

const mutationKey = ['postApiSessionsAdminGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsAdminGet>>, {data: SessionAdminGetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsAdminGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsAdminGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsAdminGet>>>
    export type PostApiSessionsAdminGetMutationBody = SessionAdminGetRequest
    export type PostApiSessionsAdminGetMutationError = unknown

    export const usePostApiSessionsAdminGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminGet>>, TError,{data: SessionAdminGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsAdminGet>>,
        TError,
        {data: SessionAdminGetRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsAdminGetMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsThinkingUrl = () => {




  return `/api/sessions/thinking`
}

export const postApiSessionsThinking = async (sessionThinkingRequest: SessionThinkingRequest, options?: RequestInit): Promise<SessionThinkingResponse> => {

  return orvalControlFetch<SessionThinkingResponse>(getPostApiSessionsThinkingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionThinkingRequest,)
  }
);}




export const getPostApiSessionsThinkingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsThinking>>, TError,{data: SessionThinkingRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsThinking>>, TError,{data: SessionThinkingRequest}, TContext> => {

const mutationKey = ['postApiSessionsThinking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsThinking>>, {data: SessionThinkingRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsThinking(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsThinkingMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsThinking>>>
    export type PostApiSessionsThinkingMutationBody = SessionThinkingRequest
    export type PostApiSessionsThinkingMutationError = unknown

    export const usePostApiSessionsThinking = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsThinking>>, TError,{data: SessionThinkingRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsThinking>>,
        TError,
        {data: SessionThinkingRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsThinkingMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsAdminSendUrl = () => {




  return `/api/sessions/admin/send`
}

export const postApiSessionsAdminSend = async (sessionAdminSendRequest: SessionAdminSendRequest, options?: RequestInit): Promise<SessionSendResponse> => {

  return orvalControlFetch<SessionSendResponse>(getPostApiSessionsAdminSendUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionAdminSendRequest,)
  }
);}




export const getPostApiSessionsAdminSendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminSend>>, TError,{data: SessionAdminSendRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminSend>>, TError,{data: SessionAdminSendRequest}, TContext> => {

const mutationKey = ['postApiSessionsAdminSend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsAdminSend>>, {data: SessionAdminSendRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsAdminSend(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsAdminSendMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsAdminSend>>>
    export type PostApiSessionsAdminSendMutationBody = SessionAdminSendRequest
    export type PostApiSessionsAdminSendMutationError = unknown

    export const usePostApiSessionsAdminSend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminSend>>, TError,{data: SessionAdminSendRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsAdminSend>>,
        TError,
        {data: SessionAdminSendRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsAdminSendMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsLiveUrl = () => {




  return `/api/sessions/live`
}

export const postApiSessionsLive = async (sessionLiveStreamRequest: SessionLiveStreamRequest, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiSessionsLiveUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionLiveStreamRequest,)
  }
);}




export const getPostApiSessionsLiveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsLive>>, TError,{data: SessionLiveStreamRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsLive>>, TError,{data: SessionLiveStreamRequest}, TContext> => {

const mutationKey = ['postApiSessionsLive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsLive>>, {data: SessionLiveStreamRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsLive(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsLiveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsLive>>>
    export type PostApiSessionsLiveMutationBody = SessionLiveStreamRequest
    export type PostApiSessionsLiveMutationError = unknown

    export const usePostApiSessionsLive = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsLive>>, TError,{data: SessionLiveStreamRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsLive>>,
        TError,
        {data: SessionLiveStreamRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsLiveMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsAdminLiveUrl = () => {




  return `/api/sessions/admin/live`
}

export const postApiSessionsAdminLive = async (sessionAdminLiveStreamRequest: SessionAdminLiveStreamRequest, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiSessionsAdminLiveUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionAdminLiveStreamRequest,)
  }
);}




export const getPostApiSessionsAdminLiveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminLive>>, TError,{data: SessionAdminLiveStreamRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminLive>>, TError,{data: SessionAdminLiveStreamRequest}, TContext> => {

const mutationKey = ['postApiSessionsAdminLive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsAdminLive>>, {data: SessionAdminLiveStreamRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsAdminLive(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsAdminLiveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsAdminLive>>>
    export type PostApiSessionsAdminLiveMutationBody = SessionAdminLiveStreamRequest
    export type PostApiSessionsAdminLiveMutationError = unknown

    export const usePostApiSessionsAdminLive = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminLive>>, TError,{data: SessionAdminLiveStreamRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsAdminLive>>,
        TError,
        {data: SessionAdminLiveStreamRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsAdminLiveMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsFilesUploadUrl = () => {




  return `/api/sessions/files/upload`
}

export const postApiSessionsFilesUpload = async (sessionFileUploadRequest: SessionFileUploadRequest, options?: RequestInit): Promise<SessionFileUploadResponse> => {

  return orvalControlFetch<SessionFileUploadResponse>(getPostApiSessionsFilesUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionFileUploadRequest,)
  }
);}




export const getPostApiSessionsFilesUploadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsFilesUpload>>, TError,{data: SessionFileUploadRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsFilesUpload>>, TError,{data: SessionFileUploadRequest}, TContext> => {

const mutationKey = ['postApiSessionsFilesUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsFilesUpload>>, {data: SessionFileUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsFilesUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsFilesUploadMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsFilesUpload>>>
    export type PostApiSessionsFilesUploadMutationBody = SessionFileUploadRequest
    export type PostApiSessionsFilesUploadMutationError = unknown

    export const usePostApiSessionsFilesUpload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsFilesUpload>>, TError,{data: SessionFileUploadRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsFilesUpload>>,
        TError,
        {data: SessionFileUploadRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsFilesUploadMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsFilesGetUrl = () => {




  return `/api/sessions/files/get`
}

export const postApiSessionsFilesGet = async (sessionFileGetRequest: SessionFileGetRequest, options?: RequestInit): Promise<SessionFileContentResponse> => {

  return orvalControlFetch<SessionFileContentResponse>(getPostApiSessionsFilesGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionFileGetRequest,)
  }
);}




export const getPostApiSessionsFilesGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsFilesGet>>, TError,{data: SessionFileGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsFilesGet>>, TError,{data: SessionFileGetRequest}, TContext> => {

const mutationKey = ['postApiSessionsFilesGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsFilesGet>>, {data: SessionFileGetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsFilesGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsFilesGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsFilesGet>>>
    export type PostApiSessionsFilesGetMutationBody = SessionFileGetRequest
    export type PostApiSessionsFilesGetMutationError = unknown

    export const usePostApiSessionsFilesGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsFilesGet>>, TError,{data: SessionFileGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsFilesGet>>,
        TError,
        {data: SessionFileGetRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsFilesGetMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsAdminFilesGetUrl = () => {




  return `/api/sessions/admin/files/get`
}

export const postApiSessionsAdminFilesGet = async (sessionAdminFileGetRequest: SessionAdminFileGetRequest, options?: RequestInit): Promise<SessionFileContentResponse> => {

  return orvalControlFetch<SessionFileContentResponse>(getPostApiSessionsAdminFilesGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionAdminFileGetRequest,)
  }
);}




export const getPostApiSessionsAdminFilesGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminFilesGet>>, TError,{data: SessionAdminFileGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminFilesGet>>, TError,{data: SessionAdminFileGetRequest}, TContext> => {

const mutationKey = ['postApiSessionsAdminFilesGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsAdminFilesGet>>, {data: SessionAdminFileGetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsAdminFilesGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsAdminFilesGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsAdminFilesGet>>>
    export type PostApiSessionsAdminFilesGetMutationBody = SessionAdminFileGetRequest
    export type PostApiSessionsAdminFilesGetMutationError = unknown

    export const usePostApiSessionsAdminFilesGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminFilesGet>>, TError,{data: SessionAdminFileGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsAdminFilesGet>>,
        TError,
        {data: SessionAdminFileGetRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsAdminFilesGetMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsArtifactsGetUrl = () => {




  return `/api/sessions/artifacts/get`
}

export const postApiSessionsArtifactsGet = async (sessionArtifactGetRequest: SessionArtifactGetRequest, options?: RequestInit): Promise<SessionArtifactContentResponse> => {

  return orvalControlFetch<SessionArtifactContentResponse>(getPostApiSessionsArtifactsGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionArtifactGetRequest,)
  }
);}




export const getPostApiSessionsArtifactsGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsArtifactsGet>>, TError,{data: SessionArtifactGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsArtifactsGet>>, TError,{data: SessionArtifactGetRequest}, TContext> => {

const mutationKey = ['postApiSessionsArtifactsGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsArtifactsGet>>, {data: SessionArtifactGetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsArtifactsGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsArtifactsGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsArtifactsGet>>>
    export type PostApiSessionsArtifactsGetMutationBody = SessionArtifactGetRequest
    export type PostApiSessionsArtifactsGetMutationError = unknown

    export const usePostApiSessionsArtifactsGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsArtifactsGet>>, TError,{data: SessionArtifactGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsArtifactsGet>>,
        TError,
        {data: SessionArtifactGetRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsArtifactsGetMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsAdminArtifactsGetUrl = () => {




  return `/api/sessions/admin/artifacts/get`
}

export const postApiSessionsAdminArtifactsGet = async (sessionAdminArtifactGetRequest: SessionAdminArtifactGetRequest, options?: RequestInit): Promise<SessionArtifactContentResponse> => {

  return orvalControlFetch<SessionArtifactContentResponse>(getPostApiSessionsAdminArtifactsGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionAdminArtifactGetRequest,)
  }
);}




export const getPostApiSessionsAdminArtifactsGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminArtifactsGet>>, TError,{data: SessionAdminArtifactGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminArtifactsGet>>, TError,{data: SessionAdminArtifactGetRequest}, TContext> => {

const mutationKey = ['postApiSessionsAdminArtifactsGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsAdminArtifactsGet>>, {data: SessionAdminArtifactGetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsAdminArtifactsGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsAdminArtifactsGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsAdminArtifactsGet>>>
    export type PostApiSessionsAdminArtifactsGetMutationBody = SessionAdminArtifactGetRequest
    export type PostApiSessionsAdminArtifactsGetMutationError = unknown

    export const usePostApiSessionsAdminArtifactsGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsAdminArtifactsGet>>, TError,{data: SessionAdminArtifactGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsAdminArtifactsGet>>,
        TError,
        {data: SessionAdminArtifactGetRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsAdminArtifactsGetMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsRuntimeContextUrl = () => {




  return `/api/sessions/runtime/context`
}

export const postApiSessionsRuntimeContext = async (sessionRuntimeContextRequest: SessionRuntimeContextRequest, options?: RequestInit): Promise<SessionRuntimeContextResponse> => {

  return orvalControlFetch<SessionRuntimeContextResponse>(getPostApiSessionsRuntimeContextUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionRuntimeContextRequest,)
  }
);}




export const getPostApiSessionsRuntimeContextMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeContext>>, TError,{data: SessionRuntimeContextRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeContext>>, TError,{data: SessionRuntimeContextRequest}, TContext> => {

const mutationKey = ['postApiSessionsRuntimeContext'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsRuntimeContext>>, {data: SessionRuntimeContextRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsRuntimeContext(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsRuntimeContextMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsRuntimeContext>>>
    export type PostApiSessionsRuntimeContextMutationBody = SessionRuntimeContextRequest
    export type PostApiSessionsRuntimeContextMutationError = unknown

    export const usePostApiSessionsRuntimeContext = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeContext>>, TError,{data: SessionRuntimeContextRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsRuntimeContext>>,
        TError,
        {data: SessionRuntimeContextRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsRuntimeContextMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsRuntimeFilesGetUrl = () => {




  return `/api/sessions/runtime/files/get`
}

export const postApiSessionsRuntimeFilesGet = async (sessionRuntimeFileGetRequest: SessionRuntimeFileGetRequest, options?: RequestInit): Promise<SessionRuntimeFileGetResponse> => {

  return orvalControlFetch<SessionRuntimeFileGetResponse>(getPostApiSessionsRuntimeFilesGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionRuntimeFileGetRequest,)
  }
);}




export const getPostApiSessionsRuntimeFilesGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeFilesGet>>, TError,{data: SessionRuntimeFileGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeFilesGet>>, TError,{data: SessionRuntimeFileGetRequest}, TContext> => {

const mutationKey = ['postApiSessionsRuntimeFilesGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsRuntimeFilesGet>>, {data: SessionRuntimeFileGetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsRuntimeFilesGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsRuntimeFilesGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsRuntimeFilesGet>>>
    export type PostApiSessionsRuntimeFilesGetMutationBody = SessionRuntimeFileGetRequest
    export type PostApiSessionsRuntimeFilesGetMutationError = unknown

    export const usePostApiSessionsRuntimeFilesGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeFilesGet>>, TError,{data: SessionRuntimeFileGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsRuntimeFilesGet>>,
        TError,
        {data: SessionRuntimeFileGetRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsRuntimeFilesGetMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsRuntimeArtifactsGetUrl = () => {




  return `/api/sessions/runtime/artifacts/get`
}

export const postApiSessionsRuntimeArtifactsGet = async (sessionRuntimeArtifactGetRequest: SessionRuntimeArtifactGetRequest, options?: RequestInit): Promise<SessionRuntimeArtifactGetResponse> => {

  return orvalControlFetch<SessionRuntimeArtifactGetResponse>(getPostApiSessionsRuntimeArtifactsGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionRuntimeArtifactGetRequest,)
  }
);}




export const getPostApiSessionsRuntimeArtifactsGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeArtifactsGet>>, TError,{data: SessionRuntimeArtifactGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeArtifactsGet>>, TError,{data: SessionRuntimeArtifactGetRequest}, TContext> => {

const mutationKey = ['postApiSessionsRuntimeArtifactsGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsRuntimeArtifactsGet>>, {data: SessionRuntimeArtifactGetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsRuntimeArtifactsGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsRuntimeArtifactsGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsRuntimeArtifactsGet>>>
    export type PostApiSessionsRuntimeArtifactsGetMutationBody = SessionRuntimeArtifactGetRequest
    export type PostApiSessionsRuntimeArtifactsGetMutationError = unknown

    export const usePostApiSessionsRuntimeArtifactsGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeArtifactsGet>>, TError,{data: SessionRuntimeArtifactGetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsRuntimeArtifactsGet>>,
        TError,
        {data: SessionRuntimeArtifactGetRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsRuntimeArtifactsGetMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsRuntimeRelayInboundUrl = () => {




  return `/api/sessions/runtime/relay/inbound`
}

export const postApiSessionsRuntimeRelayInbound = async (sessionRelayInboundRequest: SessionRelayInboundRequest, options?: RequestInit): Promise<SessionRelayInboundResponse> => {

  return orvalControlFetch<SessionRelayInboundResponse>(getPostApiSessionsRuntimeRelayInboundUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionRelayInboundRequest,)
  }
);}




export const getPostApiSessionsRuntimeRelayInboundMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayInbound>>, TError,{data: SessionRelayInboundRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayInbound>>, TError,{data: SessionRelayInboundRequest}, TContext> => {

const mutationKey = ['postApiSessionsRuntimeRelayInbound'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayInbound>>, {data: SessionRelayInboundRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsRuntimeRelayInbound(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsRuntimeRelayInboundMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayInbound>>>
    export type PostApiSessionsRuntimeRelayInboundMutationBody = SessionRelayInboundRequest
    export type PostApiSessionsRuntimeRelayInboundMutationError = unknown

    export const usePostApiSessionsRuntimeRelayInbound = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayInbound>>, TError,{data: SessionRelayInboundRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsRuntimeRelayInbound>>,
        TError,
        {data: SessionRelayInboundRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsRuntimeRelayInboundMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsRuntimeRelayDeliveryUrl = () => {




  return `/api/sessions/runtime/relay/delivery`
}

export const postApiSessionsRuntimeRelayDelivery = async (sessionRelayDeliveryRequest: SessionRelayDeliveryRequest, options?: RequestInit): Promise<SessionRelayDeliveryResponse> => {

  return orvalControlFetch<SessionRelayDeliveryResponse>(getPostApiSessionsRuntimeRelayDeliveryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionRelayDeliveryRequest,)
  }
);}




export const getPostApiSessionsRuntimeRelayDeliveryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayDelivery>>, TError,{data: SessionRelayDeliveryRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayDelivery>>, TError,{data: SessionRelayDeliveryRequest}, TContext> => {

const mutationKey = ['postApiSessionsRuntimeRelayDelivery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayDelivery>>, {data: SessionRelayDeliveryRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsRuntimeRelayDelivery(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsRuntimeRelayDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayDelivery>>>
    export type PostApiSessionsRuntimeRelayDeliveryMutationBody = SessionRelayDeliveryRequest
    export type PostApiSessionsRuntimeRelayDeliveryMutationError = unknown

    export const usePostApiSessionsRuntimeRelayDelivery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayDelivery>>, TError,{data: SessionRelayDeliveryRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsRuntimeRelayDelivery>>,
        TError,
        {data: SessionRelayDeliveryRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsRuntimeRelayDeliveryMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsRuntimeRelayFileUrl = () => {




  return `/api/sessions/runtime/relay/file`
}

export const postApiSessionsRuntimeRelayFile = async (sessionRelayFileRequest: SessionRelayFileRequest, options?: RequestInit): Promise<SessionRelayFileResponse> => {

  return orvalControlFetch<SessionRelayFileResponse>(getPostApiSessionsRuntimeRelayFileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionRelayFileRequest,)
  }
);}




export const getPostApiSessionsRuntimeRelayFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayFile>>, TError,{data: SessionRelayFileRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayFile>>, TError,{data: SessionRelayFileRequest}, TContext> => {

const mutationKey = ['postApiSessionsRuntimeRelayFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayFile>>, {data: SessionRelayFileRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsRuntimeRelayFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsRuntimeRelayFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayFile>>>
    export type PostApiSessionsRuntimeRelayFileMutationBody = SessionRelayFileRequest
    export type PostApiSessionsRuntimeRelayFileMutationError = unknown

    export const usePostApiSessionsRuntimeRelayFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayFile>>, TError,{data: SessionRelayFileRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsRuntimeRelayFile>>,
        TError,
        {data: SessionRelayFileRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsRuntimeRelayFileMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsRuntimeRelayArtifactUrl = () => {




  return `/api/sessions/runtime/relay/artifact`
}

export const postApiSessionsRuntimeRelayArtifact = async (sessionRelayArtifactRequest: SessionRelayArtifactRequest, options?: RequestInit): Promise<SessionRelayArtifactResponse> => {

  return orvalControlFetch<SessionRelayArtifactResponse>(getPostApiSessionsRuntimeRelayArtifactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionRelayArtifactRequest,)
  }
);}




export const getPostApiSessionsRuntimeRelayArtifactMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayArtifact>>, TError,{data: SessionRelayArtifactRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayArtifact>>, TError,{data: SessionRelayArtifactRequest}, TContext> => {

const mutationKey = ['postApiSessionsRuntimeRelayArtifact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayArtifact>>, {data: SessionRelayArtifactRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsRuntimeRelayArtifact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsRuntimeRelayArtifactMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayArtifact>>>
    export type PostApiSessionsRuntimeRelayArtifactMutationBody = SessionRelayArtifactRequest
    export type PostApiSessionsRuntimeRelayArtifactMutationError = unknown

    export const usePostApiSessionsRuntimeRelayArtifact = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayArtifact>>, TError,{data: SessionRelayArtifactRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsRuntimeRelayArtifact>>,
        TError,
        {data: SessionRelayArtifactRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsRuntimeRelayArtifactMutationOptions(options), queryClient);
    }
    export const getPostApiSessionsRuntimeRelayLiveEventUrl = () => {




  return `/api/sessions/runtime/relay/live-event`
}

export const postApiSessionsRuntimeRelayLiveEvent = async (sessionRelayRuntimeEventRequest: SessionRelayRuntimeEventRequest, options?: RequestInit): Promise<SessionRelayRuntimeEventResponse> => {

  return orvalControlFetch<SessionRelayRuntimeEventResponse>(getPostApiSessionsRuntimeRelayLiveEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sessionRelayRuntimeEventRequest,)
  }
);}




export const getPostApiSessionsRuntimeRelayLiveEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayLiveEvent>>, TError,{data: SessionRelayRuntimeEventRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayLiveEvent>>, TError,{data: SessionRelayRuntimeEventRequest}, TContext> => {

const mutationKey = ['postApiSessionsRuntimeRelayLiveEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayLiveEvent>>, {data: SessionRelayRuntimeEventRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSessionsRuntimeRelayLiveEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSessionsRuntimeRelayLiveEventMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayLiveEvent>>>
    export type PostApiSessionsRuntimeRelayLiveEventMutationBody = SessionRelayRuntimeEventRequest
    export type PostApiSessionsRuntimeRelayLiveEventMutationError = unknown

    export const usePostApiSessionsRuntimeRelayLiveEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSessionsRuntimeRelayLiveEvent>>, TError,{data: SessionRelayRuntimeEventRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSessionsRuntimeRelayLiveEvent>>,
        TError,
        {data: SessionRelayRuntimeEventRequest},
        TContext
      > => {
      return useMutation(getPostApiSessionsRuntimeRelayLiveEventMutationOptions(options), queryClient);
    }
